import { PREVIEW_IFRAME_ID } from "../../core/constants";
import { useCallback } from "react";

export const useScrollTo = () => {
  const scrollToElement = useCallback(
    (element: Element | null, options?: ScrollIntoViewOptions) => {
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          ...options,
        });
      }
    },
    [],
  );

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
  }, []);

  const scrollToId = useCallback(
    (id: string, options?: ScrollIntoViewOptions & { offset?: number }) => {
      let element = document.querySelector(`#${id}`);

      // If not found, try to find in preview iframe
      if (!element) {
        const iframe = document.querySelector(
          `#${PREVIEW_IFRAME_ID}`,
        ) as HTMLIFrameElement;

        element = iframe?.contentDocument?.querySelector(`#${id}`) || null;
      }

      // A pixel offset (e.g. the header's current rendered height) can't be
      // expressed through scrollIntoView, which only respects the target's
      // CSS scroll-margin, so compute the scroll position manually instead.
      if (element && options?.offset != null) {
        window.scrollTo({
          behavior: "smooth",
          top:
            element.getBoundingClientRect().top +
            window.scrollY -
            options.offset,
        });
        return;
      }

      scrollToElement(element, options);
    },
    [scrollToElement],
  );

  return {
    scrollToElement,
    scrollToId,
    scrollToTop,
  };
};
